import React from 'react';
import PropTypes from 'prop-types';
// styles
import './Style/Style.css';

// update the backgroundSize of shimmer if want to use for bigger components
export const ShimmerComponent = ({ updatedStyle, children }) => {
    return <div className="shimmer-effect" style={updatedStyle} >
        {children}
    </div>
};

ShimmerComponent.propTypes = {
    updatedStyle: PropTypes.object,
    children: PropTypes.any
};